"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.migration_77_0_0 = void 0;
const ManagedConfigurationType_1 = require("../ManagedConfigurationType");
const echain_shared_quantities_1 = require("@igus/echain-shared-quantities");
/**
 * Migrate to 77.0.0
 *
 * Copy `Kette` filter properties to dedicated object `ConfigurationJson.KetteFilterProperties`
 */
const migration_77_0_0 = (json) => {
    if (json.ManagedConfigurationType !== ManagedConfigurationType_1.ManagedConfigurationType.Expert) {
        return json;
    }
    // copy filter props of Kette to dedicated object
    if (!json.IsManualMode && !json.SpecificArticles && !json.KetteFilterProperties && json.Kette) {
        const props = {};
        if (json.Kette.Versatz_mm != null) {
            props.versatz_mm = json.Kette.Versatz_mm;
        }
        else if (json.Kette.Versatz != null) {
            props.versatz_mm = (0, echain_shared_quantities_1.Q)(json.Kette.Versatz).mm;
        }
        if (json.Kette.Verfahrweg_mm != null) {
            props.verfahrweg_mm = json.Kette.Verfahrweg_mm;
        }
        else if (json.Kette.Verfahrweg != null) {
            props.verfahrweg_mm = (0, echain_shared_quantities_1.Q)(json.Kette.Verfahrweg).mm;
        }
        if (json.Kette.LangerWeg != null) {
            props.langerWeg = json.Kette.LangerWeg;
        }
        if (json.Kette.Einspeisung != null) {
            props.einspeisung = json.Kette.Einspeisung;
        }
        if (Object.keys(props).length) {
            json.KetteFilterProperties = props;
        }
    }
    // remove Kette if it has no `ArtNrGenerated`
    if (json.Kette && !json.Kette.ArtNrGenerated) {
        delete json.Kette;
    }
    return json;
};
exports.migration_77_0_0 = migration_77_0_0;
//# sourceMappingURL=migration_77_0_0.js.map